<template>
  <el-scrollbar ref="scrollbar" class="page_main_height">
    <el-row>
      <div class="game_bxzl" :style="'background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/games/bxzl/bxzlBac.png); background-size: 100% 100%; background-repeat: no-repeat'">
        <div class="big_screen" @click="video_show = false">
          <index_head />
          <!--页面主体-->
          <!--视频-->
          <div class="bxzl_video">
            <div class="bxzl_video_title">
              <div class="bxzl_video_title_logo">
                <img :src="filePath + '/nemojoyWebSiteFile/imgs/games/bxzl/bxzlVideoLogo.png'" alt="" draggable="false">
              </div>
              <div class="bxzl_video_title_text">
                <div>WATCH THE</div>
                <div>TRAILER</div>
              </div>
            </div>
            <div class="bxzl_video_main" :style="'background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/games/bxzl/bxzlVideoBac.png); background-size: 100% 100%; background-repeat: no-repeat;'" @click="video_show = !video_show" @click.stop="">
              <div class="bxzl_video_main_bac" :style="'background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/games/bxzl/bxzlVideoImg.png); background-size: 100% 100%;'">
                <div class="bxzl_video_main_bac2" :style="'background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/games/bxzl/bxzlVideoBac2.png); background-size: 100% 100%; background-repeat: no-repeat;'">
                  <div class="bxzl_video_main_bac3" :style="'background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/games/bxzl/bxzlVideoBac3.png); background-repeat: no-repeat; background-size: 100% 100%;'" />
                </div>
              </div>
            </div>
          </div>
          <!--游戏立绘-->
          <div class="bxzl_painting">
            <img :src="filePath + (d.c.i || '/nemojoyWebSiteFile/imgs/games/bxzl/bxzlPainting.png')" alt="" draggable="false">
          </div>
          <!--底部背景图-->
          <div class="bxzl_bottom">
            <div class="bxzl_bottom_position">
              <div class="bxzl_bottom_line" :style="'background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/games/bxzl/bxzlBottomLine.png); background-repeat: no-repeat; background-size: 100% 100%;'" />
            </div>
          </div>
          <!--地图文本-->
          <div class="bxzl_bottom_text">
            <div class="bxzl_bottom_text_main">
              <a href="http://game.leiting.com/list/bxzl/home?vid=img-topbar0910" target="_blank">
                <div class="bxzl_bottom_text_go" :style="'background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/games/bxzl/bxzlGo.png); background-repeat: no-repeat; background-size: 100% 100%;'" />
              </a>
              <div class="bxzl_bottom_text_content">{{ d.n || 'THE STORY' }}</div>
              <div class="bxzl_bottom_text_content2">
                {{ d.c.c || 'Foaturing opic Nigh-octane action morments sot in the most basutiful hostee environments on carth Rise。the Tomb Ralder dolvers a cinomate SurtNa action adrenburo horeyou w& Join Lora Cron on her和rst tomb raiding opodtion as she sooks to discover the secret o limmerlalty !' }}
              </div>
            </div>
          </div>
          <!--切换按钮-->
          <div class="bxzl_switch" />

          <div :class="video_show ? 'video_show' : 'video_hidden'" class="bxzl_video_iframe">
            <iframe :src="d.c.vu || '//player.bilibili.com/player.html?aid=456973403&bvid=BV1G5411b7bZ&cid=232078076&page=1'" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true" />
          </div>
        </div>

        <!--小屏显示-->
        <div class="small_screen">
          手机页面正在建设中，请使用pc浏览器打开
        </div>
      </div>
    </el-row>
  </el-scrollbar>
</template>

<script>
import { select_show } from '@/api/games'
import vv from '@/components/varVariable'

export default {
  name: 'BuXiuZhiLv',
  data: function() {
    return {
      video_show: false,
      d: {
        n: '',
        c: {
          c: '',
          i: '',
          u: '',
          vu: ''
        }
      }
    }
  },
  computed: {
    filePath() {
      return vv.fileHttp
    }
  },
  created() {
    select_show(1)
      .then(rep => {
        this.d = rep
      })
  },
  methods: {
    close_video() {
      this.video_show = false
    },
    video_click() {
      this.video_show = !this.video_show
    }
  }
}
</script>

<style lang="scss" scoped>
.game_bxzl{
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .big_screen{
    width: 100%;
    height: 100%;
    overflow: hidden;

    .bxzl_video{
      display: inline-block;
      position: absolute;
      top: 100px;
      left: 335px;
      z-index: 3;

      .bxzl_video_title{
        display: flex;
        align-items: center;
        font-size: 30px;
        font-weight: bold;

        .bxzl_video_title_logo{
          width: 82px;
          height: 82px;

          img{
            width: 100%;
            height: 100%;
          }
        }

        .bxzl_video_title_text{
          margin-left: 30px;
          line-height: 30px;
          color: #740707;

          div:first-child{
            color: white;
          }
        }
      }

      .bxzl_video_main{
        width: 360px;
        height: 240px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;

        .bxzl_video_main_bac{
          width: 320px;
          height: 200px;
          display: flex;
          align-items: center;
          justify-content: center;

          .bxzl_video_main_bac2{
            width: 73px;
            height: 73px;
            display: flex;
            align-items: center;
            justify-content: center;

            .bxzl_video_main_bac3{
              width: 25px;
              height: 25px;
            }
          }
        }
      }

      .bxzl_video_main:hover{
        .bxzl_video_main_bac2{
          zoom: 1.1;
        }
      }
    }

    .bxzl_painting{
      width: 995px;
      height: 675px;
      position: absolute;
      //top: 60px;
      top: 50%;
      margin-top: -420px;
      right: 0;
      z-index: 2;
      animation: painting_animation 3s infinite;
      -webkit-animation: painting_animation 3s infinite;
      animation-timing-function: ease;

      img{
        width: 100%;
        height: 100%;
      }
    }

    .bxzl_bottom{
      width: 100%;
      height: 65%;
      overflow: hidden;
      text-align: center;
      position: absolute;
      bottom: 0;

      .bxzl_bottom_position{
        width: 120%;
        height: 150%;
        transform: rotate(11deg);
        background-color: rgba(0, 0, 0, .7);
        position: relative;
        left: -20%;
        top: 37%;

        .bxzl_bottom_line{
          width: 100%;
          height: 40px;
          position: relative;
          top: -15px;
        }
      }
    }

    .bxzl_bottom_text{
      width: 100vw;
      //width: 660px;
      //height: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      //margin-top: 120px;
      //margin-left: 50%;
      position: absolute;
      //left: -330px;
      //top: 550px;
      z-index: 3;
      bottom: 0;

      .bxzl_bottom_text_main{
        width: 40%;
        min-width: 660px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-bottom: 40px;

        a{
          display: inline-block;
          cursor: pointer;

          .bxzl_bottom_text_go{
            width: 172px;
            height: 47.3px;
            margin: 0 auto 15px auto;
          }
        }

        .bxzl_bottom_text_content{
          color: white;
          font-size: 36px;
          font-weight: bold;
        }

        .bxzl_bottom_text_content2{
          width: 660px;
          font-size: 14px;
          text-align: left;
          margin: 20px auto 0 auto;
          line-height: 27px;
          color: rgba(255, 255, 255, .7);
        }
      }
    }

    .bxzl_video_iframe{
      width: 80vw;
      height: 45vw;
      position: absolute;
      left: 10vw;
      z-index: 101;
      margin-top: -22.5vw;

      iframe{
        width: 100%;
        height: 100%;
      }
    }

    .video_show{
      top: 50%;
      transition: top 1s;
    }

    .video_hidden{
      top: -130vw;
      transition: top 1s;
    }
  }
}

/*立绘动画*/
@keyframes painting_animation {
  0% {
    transform:translateY(0);
  }
  50%{
    transform:translateY(6px);
  }
  100% {
    transform:translateY(0);
  }
}
</style>
